@use '@css/variables';

.cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;

  .card {
    padding: 1.5rem;
    text-align: center;
    background-color: white;
    border: 1px solid var(--beigedarker);
    border-radius: var(--border-radius);
  }

  .link {
    margin-bottom: 0;
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .cards {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
